export default {
  data () {
    return { };
  },
  computed: {
    teams () {
      let teams = [];
      const userInTeams = [];
      const userNotInTeams = [];
      const emptyRows = [];

      for (const key in this.scheduleData.teams) {
        if (this.scheduleData.teams[key].department_id == this.departmentId && this.scheduleData.teams[key].division_id == this.divisionId) {
          teams.push(this.scheduleData.teams[key]);

          for (const user of this.scheduleData.teams[key].users) {
            userInTeams.push(parseInt(user.user_id));
          }
        }
      }

      for (const user of this.users) {
        if (!user.id) {
          user.id = 0;
          emptyRows.push({ user_id: 0 });
          continue;
        } else if (!userInTeams.includes(parseInt(user.id))) {
          userNotInTeams.push({ user_id: parseInt(user.id) });
        }
      }

      if (userNotInTeams.length > 0) {
        teams.push({
          id: 'no-team',
          name: this.$t('work-schedule.no-team'),
          color_hex: '#fff6f0',
          users: userNotInTeams,
          sequence: 9999
        });
      }

      teams.push({
        id: 'empty-row',
        name: this.$t('work-schedule.empty-row'),
        color_hex: '#fff',
        users: emptyRows,
        sequence: 9999
      });

      teams = this.BasicHelper.sortArrayByKeyValue(teams, 'sequence');

      return teams;
    },
    users () {
      const key = this.departmentId + (this.divisionId ? '_' + this.divisionId : '');
      let users = Object.values(this.scheduleData.users[key] ? this.scheduleData.users[key] : []);

      users = this.BasicHelper.sortArrayByKeyValue(users, 'fullname');
      users = users.sort((a, b) => {
        if (a.order < b.order) {
          return 1;
        }

        return -1;
      });

      return users;
    },
    usersByTeam () {
      const data = {};
      for (const item of this.teams) {
        data[item.id] = [];
        for (const key in this.users) {
          if (item.users.map(a => a.user_id).includes(parseInt(this.users[key].id))) {
            data[item.id].push(this.users[key]);
          }
        }
      }
      return data;
    }
  },
  methods: {
    showTeam (team) {
      if (team.id == 'no-team' || team.id == 'empty-row') {
        return true;
      }

      return this.usersByTeam[team.id].length && (!this.filterData.team_id || (!this.filterData.team_id.length || this.filterData.team_id.includes(team.id)));
    }
  }
};
